module.exports = __webpack_public_path__ + "img/clipboard_refund.977bca1d.png";